import {put} from 'redux-saga/effects';
import {actionTypes as statsTypes} from 'features/stats';

export default function* tryProductsGet({data}) {
  if (data.productIds.length > 0) {
    yield put({type: statsTypes.GET_TRY, data: {productIds: data.productIds}});
  }
}
